// AutoScout24-style grouped equipment options with checkboxes (car category).
export const OPTION_GROUPS = [
  {
    label: "Confort",
    items: ["Climatisation", "Climatisation automatique", "Climatisation bi-zone", "Climatisation 4 zones",
      "Sièges chauffants", "Sièges ventilés", "Sièges électriques", "Sièges à mémoire", "Volant chauffant",
      "Régulateur de vitesse", "Régulateur adaptatif (ACC)", "Accès sans clé", "Démarrage sans clé",
      "Toit ouvrant", "Toit panoramique", "Hayon électrique", "Vitres électriques", "Rétroviseurs rabattables électriques",
      "Suspension pneumatique", "Start/Stop"],
  },
  {
    label: "Sécurité & assistance",
    items: ["ABS", "ESP", "Airbags", "Freinage d'urgence automatique", "Aide au maintien de voie",
      "Détecteur d'angle mort", "Alerte de franchissement de ligne", "Caméra de recul", "Caméra 360°",
      "Radar de recul", "Radar avant", "Aide au stationnement", "Stationnement automatique",
      "Reconnaissance des panneaux", "Vision nocturne", "Alerte de somnolence", "Feux automatiques", "Isofix"],
  },
  {
    label: "Multimédia",
    items: ["Bluetooth", "Apple CarPlay", "Android Auto", "Navigation GPS", "Écran tactile",
      "Système audio premium", "Chargeur à induction", "Prises USB", "DAB+", "Affichage tête haute (HUD)",
      "Combiné numérique", "Commandes vocales"],
  },
  {
    label: "Extérieur",
    items: ["Jantes alliage", "Feux LED", "Feux Xénon", "Feux Matrix LED", "Barres de toit", "Attelage",
      "Vitres surteintées", "Peinture métallisée", "Pack sport extérieur"],
  },
  {
    label: "Intérieur",
    items: ["Sellerie cuir", "Sellerie Alcantara", "Sièges sport", "Volant cuir", "Volant sport",
      "Ambiance lumineuse", "Palettes au volant", "Accoudoir central", "Seuils de porte éclairés"],
  },
];
